<template>
    <FciDialog :title="this.$f.tc('step')" v-model="show">
        <v-form ref="form" v-model="formValid" @submit="submit" class="StepSelector pa-3">
            <v-autocomplete
                :items="stepList"
                item-text="name"
                item-value="code"
                v-model="stepCode"
                outlined
                dense
                :label="this.$f.tc('step')"
            ></v-autocomplete>
            <v-layout>
                <v-flex></v-flex>
                <v-btn color="primary" type="submit">{{ $t('select') }}</v-btn>
            </v-layout>
        </v-form>
    </FciDialog>
</template>

<script>
import FciDialog from '@/components/FciDialog'
import DialogPromiseFormMixin from '@/modules/fptai/mixins/DialogPromiseFormMixin'

export default {
    name: 'StepSelector',
    components: { FciDialog },
    mixins: [DialogPromiseFormMixin],
    data () {
        return {
            stepCode: '',
            allowSpecialStep: false,
            stepList: []
        }
    },
    methods: {
        open ({
            stepCode,
            allowSpecialStep
        }) {
            this.stepCode = stepCode || ''
            this.allowSpecialStep = allowSpecialStep || false
            if (this.allowSpecialStep) {
                this.stepList = this.$store.state.scenario.stepList
            } else {
                let state = this.$store.state.scenario
                this.stepList = this.$store.state.scenario.stepList.filter(step => !(
                    step.code === state.reminderStepCode ||
                    step.code === state.startSessionStepCode ||
                    step.code === state.startSentenceStepCode
                ))
            }
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {
                    resolve,
                    reject
                }
            })
        },
        submitValidForm () {
            this.close()
            this.promise.resolve(this.$store.state.scenario.mapCodeToStep[this.stepCode])
        }
    }
}
</script>

<style scoped lang="scss">

</style>
